import React from 'react';
import { classList } from '../../../utils/string.ts';
import { matchesCohortFromCookie } from '../../../utils/cohort.ts';

export type Tab = {
  title: string;
  content: React.ReactNode;
};

export type TabSelectorProps = {
  className?: string;
  selectorClassName?: string;
  tabs: Tab[];
};

export const TabSelector: React.FunctionComponent<TabSelectorProps> = props => {
  const { className, selectorClassName, tabs } = props;
  const [activeTab, setActiveTab] = React.useState(0);
  const abTabSetup = matchesCohortFromCookie('sk-AB-tabsetup', '2', '3');

  return (
    <div className={className}>
      {!abTabSetup && (
        <div className={classList('bg-sk-grey-200 flex rounded-full p-1', selectorClassName)}>
          {tabs.map((tab, index) => (
            <h2
              key={index}
              className={classList(
                `inline-grid flex-1 place-items-center rounded-full p-0.5 text-center`,
                activeTab === index
                  ? 'text-sk-blue-500 bg-sk-grey-0'
                  : 'text-sk-grey-900 cursor-pointer'
              )}
              onClick={activeTab === index ? undefined : () => setActiveTab(index)}
            >
              {tab.title}
            </h2>
          ))}
        </div>
      )}

      {tabs
        .filter((_tab, index) => activeTab === index)
        .map((tab, index) => (
          <React.Fragment key={index}>{tab.content}</React.Fragment>
        ))}
    </div>
  );
};
